import { Box, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import { StyledButton } from "../../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../../shared/components/form-builder/form-builder";
import { LoaderComponent } from "../../../../shared/components/loaders/page-loader";
import ActionsModalPopup from "../../../../shared/components/modals/action-popup";
import CustomTable from "../../../../shared/components/table/custom-table";
import { useApi } from "../../../../shared/hooks/useApi";
import useNotification from "../../../../shared/hooks/useNotification";
import { Pagination } from "../../../../shared/hooks/useRecordStore";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import { mlbuyerSellerDetailsService } from "../../../transaction-certificates/tc-service/buyer-seller-details.service";
import { dtrackItService } from "../../../transaction-certificates/tc-service/dtrackit.service";
import { Utills } from "../../../../shared/app-configs/utilit";
import { MLAppConfig } from "../../ml-models/MLAppConfig";
import { PageWrapper } from "../material-ledger-summary";
import InventoryDocuments from "./inventory-details/inventory-documents";
import UpdateInventoryDetails from "./inventory-details/update-inventory";
import {
  IInventoryStepData,
  IPostInventory,
  mapApiResponseToTransactionRecord,
  TransactionRecords,
} from "./models/inventory-models";

const intInventoryData: IPostInventory = {
  tCeTCMDFNumber: "",
  productCategory: "",
  productDetail: "",
  certifiedRmCode: "",
  standard: "",
  balance: "",
  rmPercentage: "",
  volumeAdjustmentReason: [],
};

const InventoryUpdate = () => {
  const formRef = useRef<any>(null);
  const inventoryFormRef = useRef<any>(null);
  const documentsFormRef = useRef<any>(null);
  const filesFormRef = useRef<any>(null);
  const { TE_ID, RM_CODE } = useParams();
  const formRefs = [inventoryFormRef, filesFormRef];
  const { notify } = useNotification();
  const { executeGet, loading } = useApi();
  const [uploadedDocuments, setUploadedDocuments] = useState<File[]>([]);
  const { executePost:inventoryupdatepost ,loading:inventoryLoading } = useApi();
  const [stepData, setStepData] = useState<IInventoryStepData>({
    inventoryData: intInventoryData,
    documentsData: [],
    filesData: "filesData",
  });
  const [data, setData] = useState<TransactionRecords>([]);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const { cbLicensingCode } = useTransactionCertificateStore();
  const [rowCount, setRowCount] = useState<number>(0);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [showTable, setShowTable] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [bulkUploadModalOpen, setBulkUploadModalOpen] = useState(false);
  const [multiBulkUploadModalOpen, setMultiBulkUploadModalOpen] = useState(false);
  const [visible, setVisible] = useState({
    coTEId: true,
    certifiedOrganisationName: true,
  });

  const [fileName, setFileName] = useState<string[]>([]);
  const [filePath, setFilePath] = useState<string[]>([]);
  const [ledgerTransactionId, setLedgerTransactionId] = useState<string>("");
  const [coTEId, setCoTEId] = useState<string>("");
  const [standards, setStandards] = useState<string>("");
  const [organizationName, setOrganizationName] = useState<string>("");
  const [countryStateData, setCountryStateData] = useState<any>({});
  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);
  const [certifiedRawMaterialCodes, setCertifiedRawMaterialCodes] = useState<
    any[]
  >([]);
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const [productCategory, setProductCategory] = useState<any[]>([]);
  const [productDetails, setProductDetails] = useState<any[]>([]);
  const fetchRawMaterialOptions = async () => {
    try {
      const result: any = await dtrackItService.getRawMaterialCodes();
      const options = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      setRawMaterials(options);
    } catch (err) {
      console.error("Error fetching raw material codes", err);
    }
  };
  const getProductCategory = async () => {
    try {
      const result: any = await dtrackItService.getProductCategory();

      // Utills.cl(`result ${JSON.stringify(result)}`)

      const prdtCategory = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtCategory ${JSON.stringify(prdtCategory)}`);
      setProductCategory(prdtCategory);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  const getProductDetails = async () => {
    try {
      const result: any = await dtrackItService.getProductDetailsCode();

      Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

      const prdtDetails = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
      setProductDetails(prdtDetails);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  const getRawMatStandardCodes = async () => {
    const response = await executeGet(
      TCAppConfig.GET_CERTIFIED_RAW_MATERIAL_CODES
    );
    if (response?.data) {
      setCertifiedRawMaterialCodes(response.data);
    }
  };
  useEffect(() => {
    getRawMatStandardCodes();
    fetchRawMaterialOptions();
    getProductCategory();
    getProductDetails();
  }, []);
  useEffect(() => {
    if (TE_ID) {
      formRef.current?.setFieldValue("coTEId", TE_ID);
      setCoTEId(TE_ID);
      
      const fetchDetails = async () => {
        try {
          const response = await fetchTEDetallsFromAPI(TE_ID, 0, "query");
          if (response && response.length > 0) {
            const details = response[0];
            formRef.current?.setFieldValue("certifiedOrganisationName", details.account_name);
            formRef.current?.setFieldValue("address", details.street);
            formRef.current?.setFieldValue("state", details.state);
            formRef.current?.setFieldValue("postcode", details.postal_code);
            formRef.current?.setFieldValue("sellerTown", details.city);
            formRef.current?.setFieldValue("country", details.country_name);
            // Store organization name and standards in state for modal display
            setOrganizationName(details.account_name);
            setStandards(details?.standards || "");
            
            setVisible((prev) => ({
              ...prev,
              coTEId: true,
              certifiedOrganisationName: false,
            }));

            fetchInventoryUpdatesData({ coTEId: TE_ID });
          }
        } catch (error) {
          console.error("Error fetching TE details:", error);
          notify("Failed to fetch organization details", "error");
          // Clear organization data on error
          setOrganizationName("");
          setStandards("");
        }
      };

      fetchDetails();
    }
  }, [TE_ID]);

  // Refetch data when pagination changes
  useEffect(() => {
    if (coTEId && showTable) {
      fetchInventoryUpdatesData({ coTEId });
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm(); // Programmatically submit the form
    }
  };

  const handleReset = () => {
    if (formRef.current) {
      formRef.current.resetForm();
    }
    setIsFormDisabled(false);
    setShowTable(false);
    setData([]);
    setRowCount(0);
    // Clear all state variables
    setOrganizationName("");
    setCoTEId("");
    setStandards("");
    setVisible({
      coTEId: true,
      certifiedOrganisationName: true,
    });
  };
  const fetchInventoryUpdatesData = async (values: any) => {
    try {
      const teIdWithPrefix = `TE-${values.coTEId}`;
      const response = await executeGet(TCAppConfig.GET_ML_INVENTORY_UPDATES, {
        teId: teIdWithPrefix,
        ...(RM_CODE && { rawMaterialCode: RM_CODE }),
        limit: pagination?.pageSize,
        offset: pagination?.pageIndex * pagination?.pageSize,
      });
      if (response && response.data) {
        console.log(response.data);
        setData(mapApiResponseToTransactionRecord(response.data.response));
        setRowCount(response.data.no_of_records);
      }
      setShowTable(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setRowCount(0);
    }
  };
  const handleDataUpdate = (
    stepKey: keyof IInventoryStepData,
    updatedData: any
  ) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };

  //  log stepData
  useEffect(() => {
    console.log("stepData", stepData);
  }, [stepData]);

  const toggleDrawer = () => {
    setDialogOpen(!dialogOpen);
    // Only reset step data, not the search form
    if (dialogOpen) {
      setStepData({
        inventoryData: intInventoryData,
        documentsData: [],
        filesData: "filesData",
      });
    }
  };

  const toggleBulkUploadModal = () => {
    setBulkUploadModalOpen(!bulkUploadModalOpen);
  };

  const toggleMultiBulkUploadModal = () => {
    setMultiBulkUploadModalOpen(!multiBulkUploadModalOpen);
  };

  const handleDocumentUpload = (files: File[]) => {
    setUploadedDocuments(files);
    handleDataUpdate("documentsData", files);
  };
  // const steps = [
  //   {
  //     label: "Inventory Details",
  //     content: (
  //       <UpdateInventoryDetails
  //         formRef={inventoryFormRef}
  //         inventoryData={stepData.inventoryData}
  //         setInventoryData={(data) => handleDataUpdate("inventoryData", data)}
  //         loading={inventoryLoading}
  //       />
  //     ),
  //   },
  //   {
  //     label: "Upload files",
  //     content: (
  //       <InventoryDocuments
  //         formRef={documentsFormRef}
  //         documentsData={stepData.documentsData}
  //         setDocumentsData={(data:any) => handleDataUpdate("documentsData", data)}
  //         loading={loading}
  //         setFileName={setFileName}
  //         setFilePath={setFilePath}
  //       />
  //     ),
  //   },
  // ];
  const handleSellerTEIdValueChange = (value: any) => {
    const fields = [
      "certifiedOrganisationName",
      "address",
      "state",
      "postcode",
      "country",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });

      // Clear state variables when value is null
      setOrganizationName("");
      setCoTEId("");
      setStandards("");

      setVisible((prev) => ({
        ...prev,
        certifiedOrganisationName: true,
      }));
    } else {
      // Strip TE- prefix before saving
      const cleanTeid = (value.TE_ID || "").replace(/^TE-/, "");
      formRef.current.setFieldValue(
        "certifiedOrganisationName",
        value.account_name
      );
      formRef.current.setFieldValue("coTEId", cleanTeid);
      formRef.current.setFieldValue("address", value.street);
      formRef.current.setFieldValue("state", value.state);
      formRef.current.setFieldValue("postcode", value.postal_code);
      formRef.current.setFieldValue("sellerTown", value.city);
      formRef.current.setFieldValue("country", value.country_name);
      
      // Store organization name and TE ID in state for modal display
      setOrganizationName(value.account_name);
      setCoTEId(cleanTeid);
      setStandards(value?.standards || "");

      setVisible((prev) => ({
        ...prev,
        certifiedOrganisationName: false,
      }));
    }
  };
  const handleSellerNamedValueChange = (value: any) => {
    const fields = ["coTEId", "address", "state", "postcode", "country"];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });

      // Clear state variables when value is null
      setOrganizationName("");
      setCoTEId("");
      setStandards("");

      setVisible((prev) => ({
        ...prev,
        coTEId: true,
      }));
    } else {
      // Strip TE- prefix before saving
      const cleanTeid = (value.TE_ID || "").replace(/^TE-/, "");
      formRef.current.setFieldValue("coTEId", cleanTeid);
      formRef.current.setFieldValue(
        "certifiedOrganisationName",
        value.account_name
      );
      formRef.current.setFieldValue("address", value.street);
      formRef.current.setFieldValue("state", value.state);
      formRef.current.setFieldValue("postcode", value.postal_code);
      formRef.current.setFieldValue("sellerTown", value.city);
      formRef.current.setFieldValue("country", value.country_name);
      
      // Store organization name and TE ID in state for modal display
      setOrganizationName(value.account_name);
      setCoTEId(cleanTeid);
      setStandards(value?.standards || "");
      setVisible((prev) => ({
        ...prev,
        coTEId: false,
      }));
    }
  };
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
        tcCbLicensingCode: cbLicensingCode
      };
      // Fetch TE Details using the getTEDetails function
      const response = await mlbuyerSellerDetailsService.getMLCODetails(
        queryParams
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error; // Re-throw error to handle it in the calling code
    }
  };
  const formConfig = {
    pageName: "inventory-dashboard-page",
    initialValues: {
      certifiedOrganisationName: "", // For multi-select
      coTEId: "",
      address: "",
      state: "",
      postcode: "",
      country: "",
    },
    validationSchema: Yup.object().shape({
      certifiedOrganisationName: Yup.string().nullable(),
      coTEId: Yup.string().nullable(),
      address: Yup.string().nullable(),
      state: Yup.string().nullable(),
      postcode: Yup.string().nullable(),
      country: Yup.string().nullable(),
    }),
    sections: [
      {
        fields: [
          {
            label: "Certified Organization Name",
            name: "certifiedOrganisationName",
            type: "search",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            value: "",
            visible: (value: any) => visible.certifiedOrganisationName,
            disabled: isFormDisabled,
            props: {
              placeholder: "Search using Organization Name",
              variant: "outlined",
              onChange: handleSellerNamedValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Certified Organization Name",
            name: "certifiedOrganisationName",
            type: "text",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: true,
            // value: 'initialValues.sellerAddress1',
            disabled: true,
            visible: (value: any) => !visible.certifiedOrganisationName,
            props: {
              fullWidth: true,
            },
          },
          {
            label: "Certified Organization TE-ID",
            name: "coTEId",
            type: "search",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            visible: (value: any) => visible.coTEId,
            disabled: isFormDisabled,
            props: {
              placeholder: "Search using TE-ID",
              variant: "outlined",
              displayKey: "TE_ID",
              restrictInputFormat: true,
              onChange: handleSellerTEIdValueChange,
              fetchOnEmptyFocus: true,
              onSearch: async (query: string, offset: number) => {
                // When query is empty, do not fetch anything
                if (!query || query.trim() === "") {
                  return [];
                }

                // Search the API with the query (trigger after 3 letters)
                if (query.length >= 3) {
                  const response = await fetchTEDetallsFromAPI(
                    query,
                    offset,
                    "query"
                  );
                  return response;
                }

                // Return empty array if less than 3 characters
                return [];
              },
              fullWidth: true,
            },
          },
          {
            label: "CO TE-ID",
            name: "coTEId",
            type: "text",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: true,
            // value: 'initialValues.sellerAddress1',
            disabled: true,
            visible: (value: any) => !visible.coTEId,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Address",
            name: "address",
            type: "text",
            disabled: true,
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            props: {
              //   placeholder: "Enter Address"
            },
          },
          {
            label: "State/Province",
            name: "state",
            type: "text",
            disabled: true,
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            value: "",
            props: {
              //   placeholder: "Select State",
              options: [], // Empty options for now
              onChange: () => {}, // Empty handler for now
            },
          },
          {
            label: "Postcode",
            name: "postcode",
            type: "text",
            disabled: true,
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            props: {
              //   placeholder: "Enter Postal Code"
            },
          },
          {
            label: "Country/Area",
            name: "country",
            type: "text",
            disabled: true,
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            value: "",
            props: {
              //   placeholder: "Select Country",
              options: [], // Empty options for now
              onChange: () => {}, // Empty handler for now
            },
          },
          {
            label: "",
            name: "",
            type: "component",
            gridSize: { xs: 12, md: 3, lg: 3 },
            required: false,
            value: "",
            children: (
              <>
                <Box marginTop="23px" marginLeft="10px" display="flex" gap={2}>
                  <StyledButton
                    onClick={handleSubmit}
                    disabled={isFormDisabled}
                  >
                    Search
                  </StyledButton>
                  <StyledButton 
                    onClick={handleReset} 
                    variant="outlined"
                    disabled={!isFormDisabled && !showTable}
                  >
                    Reset
                  </StyledButton>
                </Box>
              </>
            ),
            props: {},
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      setCoTEId(values.coTEId);
      setCountryStateData({
        country: values.country,
        state: values.state,
      });
      if (values.coTEId) {
        await fetchInventoryUpdatesData(values);
        setIsFormDisabled(true); // Disable form after successful search
      } else {
        setShowTable(false);
      }
    },
  };
  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tCeTCMDFNumber",
      header: "Inventory Transaction No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "volumeAdjustmentReason",
      header: "Volume Adjustment Reason",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "volumeAdjustmentDate",
      header: "Volume Adjustment Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "submissionDate",
      header: "Submission Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productCategory",
      header: "Product Category",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productCategoryDesc",
      header: "Product Category Description",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetail",
      header: "Product Detail",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetailDesc",
      header: "Product Detail Description",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "rmCode",
      header: "Raw Material Code",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "rmCodeDesc",
      header: "Raw Material Code Desc",
      minSize: 60,
      maxSize: 150,
    },
    { accessorKey: "standard", header: "Standard", minSize: 60, maxSize: 150 },
    {
      accessorKey: "certifiedWeight",
      header: "Certified Weight (kg)",
      minSize: 60,
      maxSize: 150,
    },
    // {
    //   accessorKey: "files",
    //   header: "Files",
    //   minSize: 60,
    //   maxSize: 200,
    //   Cell: ({ row }: any) => <InventoryFIlesView row={row} />,
    // },
  ];
  const mapFormToPayload = async (payload: any) => {
    return {
      ledgerTransactionId: "", // Assuming this is a static value
      tCeTCMDFNumber: payload.tCeTCMDFNumber,
      productCategory: payload.productCategory,
      productDetail: payload.productDetail,
      certifiedRmCode: payload.certifiedRmCode,
      standard: payload.standard,
      balance: payload.balance,
      rmPercentage: payload.rmPercentage, // Note the corrected spelling
      country: payload.country, // Assuming these fields exist in the payload
      state: payload.state, // Assuming these fields exist in the payload
    };
  };
  // const inventorypost = async () => {
  //   console.log("s:", stepData.inventoryData);
  //   const mappedPayload = await mapFormToPayload(stepData.inventoryData);
    
  //   try {
  //     const result = await inventoryupdatepost(`${MLAppConfig.INVENTORY_UPDATE}?teId=${coTEId}&tcCbLicensingCode=${cbLicensingCode}`, mappedPayload);
  //     if (result?.status === 200) {
  //       console.log("result:-------------->", result);
  //       setLedgerTransactionId(result.data.ledgerTransactionId);
  //       notify("Saved Successfully", "success");
  //     } else {
  //       notify("Unable to Save", "error"); 
  //     }
  //   } catch (error) {
  //     console.error("Error posting inventory update:", error);
  //     notify("Failed to update inventory", "error");
  //   }

  //   // ... existing code ...,
  // };
  // const handleNext = async () => {
  //   if (formRefs[activeStep]?.current) {
  //     const errors = await formRefs[activeStep]?.current.validateForm();
  //     await formRefs[activeStep]?.current.submitForm();
  //     if (Object.keys(errors).length === 0) {
  //       await inventorypost()
  //       setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
  //     } else {
  //       notify("Please Enter the Required Values", "error");
  //     }
  //   }
  // };
  // ... existing code ...

  const handleFinish = async () => {
    if (formRefs[activeStep]?.current) {
      const errors = await formRefs[activeStep]?.current.validateForm();
      await formRefs[activeStep]?.current.submitForm();

      if (Object.keys(errors).length > 0) {
        notify("Please Enter the Required Values", "error");
        return;
      }
    }

    try {
      const payload = {
        ledgerTransactionId: ledgerTransactionId,
        tCeTCMDFNumber: stepData.inventoryData.tCeTCMDFNumber,
        productCategory: stepData.inventoryData.productCategory,
        productDetail: stepData.inventoryData.productDetail,
        certifiedRmCode: stepData.inventoryData.certifiedRmCode,
        standard: stepData.inventoryData.standard,
        balance: stepData.inventoryData.balance,
        rmPercentage: stepData.inventoryData.rmPercentage,
        country: formRef.current?.values.country || "",
        state: formRef.current?.values.state || "",
        files: {
          fileName: fileName,
          filePath: filePath,
        },
      };

      // 3. Define query params
      const queryParams = {
        teId: formRef.current?.values.coTEId || "10011",
        tcCbLicensingCode: cbLicensingCode, // Get from form or config if available
      };

      console.log("payload--------------------->", payload);
      // 4. Make API call
      const response = await inventoryupdatepost(
        `${MLAppConfig.INVENTORY_UPDATE}?teId=${coTEId}&tcCbLicensingCode=${cbLicensingCode}`,
        payload
      );

      // 5. Handle response
      if (response && response.status === 200) {
        notify("Inventory added successfully", "success");
        toggleDrawer();
      } else {
        notify("Failed to update inventory", "error");
      }
    } catch (error) {
      console.error("Error adding inventory:", error);
      notify(
        "Failed to update inventory: " +
          (error instanceof Error ? error.message : "Unknown error"),
        "error"
      );
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  // const actions: ActionButtonConfig[] = [
  //   {
  //     label: "Back",
  //     onClick: handleBack,
  //     variant: "outlined" as "outlined",
  //     color: "default" as "default",
  //   },
  //   {
  //     label: activeStep === steps.length - 1 ? "Save" : "Next",
  //     onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
  //     variant: "contained" as "contained",
  //     color: "primary" as "primary",
  //   },
  // ];

  function onEdit(row: any): void {
    toggleDrawer();
  }

  function onDelete(row: any): void {
    // throw new Error("Function not implemented.");
  }
  return (
    <PageWrapper>
      <Typography
        mt={4}
        variant="h6"
        gutterBottom
        align="left"
        fontWeight="600"
      >
        Inventory Updates
      </Typography>
      <FormBuilder formConfig={formConfig} formRef={formRef} />
      {loading ? <LoaderComponent /> : null}

      <Box display="flex" mb={3} justifyContent="flex-end" width="100%" gap={2}>
        <StyledButton variant="contained" onClick={toggleMultiBulkUploadModal}>
          Multi Bulk Upload
        </StyledButton>
      </Box>

      {showTable ? (
        <>
          <Box
            display="flex"
            mb={3}
            justifyContent="flex-end"
            width="100%"
            gap={2}
          >
            <StyledButton variant="contained" onClick={toggleBulkUploadModal}>
              Bulk Upload
            </StyledButton>
            <StyledButton
              variant="contained"
              onClick={toggleDrawer}
              disabled={!organizationName || !coTEId} // Disable button until organization is selected
            >
              Update Inventory
            </StyledButton>
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={data?.map((record)=>{
            return {...record,
              productCategoryDesc:productCategory?.find((pc:any)=>pc?.value===record?.productCategory)?.label,
              productDetailDesc:productDetails?.find((pd:any)=>pd?.value===record?.productDetail)?.label,
              rmCodeDesc:rawMaterials?.find((rm:any)=>rm?.value===record?.rmCode)?.label
            }})}
              title="Inventory Updates"
              enableTopToolbar={true}
              enableBottomToolbar={true}
              paginations={pagination} // Pass current pagination state
              setPaginations={setPagination}
              rowCount={rowCount}
              isLoadingTodos={loading}
              enableRowActions={true}
              // renderRowActions={({ row }) => (
              //   <ActionsMenu row={row} 
              //   onEdit={onEdit} onDelete={onDelete} />
              // )}
            />
          </Box>
          <ActionsModalPopup
            open={dialogOpen}
            onClose={toggleDrawer}
            title="Update Inventory"
            // actions={actions}
          >
          <UpdateInventoryDetails
              formRef={inventoryFormRef}
              inventoryData={stepData.inventoryData}
              setInventoryData={(data) => handleDataUpdate("inventoryData", data)}
              loading={inventoryLoading}
              refreshInventory={handleSubmit}
              countryStateData={countryStateData}
              coTEId={coTEId}
              standards={standards}
              certifiedRawMaterialCodes={certifiedRawMaterialCodes}
              organizationName={organizationName}
          />
          
          </ActionsModalPopup>

          {/* Bulk Upload Modal */}
          <ActionsModalPopup
            open={bulkUploadModalOpen}
            onClose={toggleBulkUploadModal}
            title="Bulk Update Inventory"
            maxWidth="70%"
            minHeight="auto"
            maxHeight="70%"
            width="50%"
          >
            <InventoryDocuments
              formRef={documentsFormRef}
              documentsData={stepData.documentsData}
              setDocumentsData={(data) => handleDataUpdate("documentsData", data)}
              loading={loading}
              refreshInventory={handleSubmit}
              setFileName={setFileName}
              setFilePath={setFilePath}
              coTEId={coTEId}
              organizationName={organizationName}
              isMultiBulkUpload={false}
            />
          </ActionsModalPopup>
        </>
      ) : null}

      <ActionsModalPopup
        open={multiBulkUploadModalOpen}
        onClose={toggleMultiBulkUploadModal}
        title="Multi Bulk Update Inventory"
        maxWidth="70%"
        minHeight="auto"
        maxHeight="70%"
        width="50%"
      >
        <InventoryDocuments
          formRef={documentsFormRef}
          documentsData={stepData.documentsData}
          setDocumentsData={(data) => handleDataUpdate("documentsData", data)}
          loading={loading}
          refreshInventory={handleSubmit}
          setFileName={setFileName}
          setFilePath={setFilePath}
          coTEId={coTEId}
          organizationName={organizationName}
          isMultiBulkUpload={true}
        />
      </ActionsModalPopup>
    </PageWrapper>
  );
};

export default InventoryUpdate;
